// Set on the first 404 from the bin-search endpoint (not deployed); hides every
// Others control until sign-out.
import { create } from "zustand";

interface OthersMembersAvailabilityStore {
  unavailable: boolean;
  markUnavailable: () => void;
  reset: () => void;
}

const initialState: Pick<OthersMembersAvailabilityStore, "unavailable"> = {
  unavailable: false
};

export const useOthersMembersAvailabilityStore = create<OthersMembersAvailabilityStore>()(
  (set, get) => ({
    ...initialState,
    markUnavailable: () => {
      if (get().unavailable) return;
      set({ unavailable: true });
    },
    reset: () => set(initialState)
  })
);

export const selectOthersMembersUnavailable = (s: OthersMembersAvailabilityStore) =>
  s.unavailable;
